<ng-select [items]="allTeams" bindLabel="teamName" bindValue="userId"
    [placeholder]='placeholder' [addTag]="allowAdding" [multiple]='allowMultiple' [hideSelected]="true" [trackByFn]="trackByFnTeam"
    [loading]="teamLoading" [typeahead]="employeeInput$" (change)="onTeamSelectChange($event)"
    (clear)="onTeamSelectRemove($event)">
    <ng-template ng-loadingspinner-tmp>
        <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </ng-template>
</ng-select>